import React, { useRef } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import './Apps.css';

function Apps() {
  const op = useRef(null);

  const apps = [
    { name: 'TRFX', icon: 'pi pi-send', url: '#' },
    { name: 'Urls', icon: 'pi pi-paperclip', url: '#' },
    { name: 'Scopes', icon: 'pi pi-address-book', url: '#' },
    { name: 'Products', icon: 'pi pi-box', url: '#' },
  ];

  return (
    <div className='apps-container'>
      <i
        className='pi pi-th-large cursor-pointer apps-icon'
        onClick={(e) => op.current.toggle(e)}
      ></i>

      <OverlayPanel ref={op} className='p-4'>
        <h3 className='apps-title'>
          <span className='apps-title-air'>air</span>
          <span className='apps-title-testtool'>TestTool</span>
        </h3>
        <div className='apps-grid'>
          {apps.map((app, index) => (
            <a key={index} href={app.url} className='apps-item'>
              <i className={`${app.icon} apps-item-icon`}></i>
              <span className='apps-item-name'>{app.name}</span>
            </a>
          ))}
        </div>
      </OverlayPanel>
    </div>
  );
}

export default Apps;
